import { styled } from '@mui/material/styles';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)({
  width: '100%',
  display: 'flex',
  padding: 0,
  gap: 0,
  borderRadius: '8px',
  border: '1px solid #DDE2E5',
  overflow: 'hidden',
  height: '36px',
  backgroundColor: '#FFFFFF',
  '& .MuiToggleButtonGroup-grouped': {
    margin: 0,
    border: 'none',
    borderRadius: 0,
    '&:not(:first-of-type)': {
      borderLeft: '1px solid #DDE2E5',
    },
  },
});

const ToggleLabel = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0,
});

const StyledToggleButton = styled(ToggleButton)({
  textTransform: 'none',
  padding: '8px',
  fontSize: '0.875rem',
  fontWeight: 500,
  lineHeight: '20px',
  border: '1px solid #E8EAEB',
  '&.Mui-selected': {
    backgroundColor: '#9AD6D1',
    color: '#162936',
    '&:hover': {
      backgroundColor: '#88D8C0',
    },
  },
  '&:not(.Mui-selected)': {
    backgroundColor: '#FFFFFF',
    flex: 1,
    color: '#6C6C6C',
    '&:hover': {
      backgroundColor: '#F8FAFB',
    },
  },
});
export { StyledToggleButtonGroup, StyledToggleButton, ToggleLabel };
